import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  margin: 30px 0;
`

export const CardHeader = styled.div`
  ${({ theme }) => css`
    display: flex;

    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    margin: 0 8px;
    height: 58px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: ${theme.border.radius} ${theme.border.radius} 0 0;
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.xbold};

    > button {
      display: flex;
      align-items: center;
      background: none;

      svg {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  `}
`

export const CardBody = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-areas:
      '. . . z z'
      'a b c . .'
      'd e f g h'
      'i j k l .'
      'm m m m m'
      '. . . . w';
    .name {
      grid-area: a;
    }
    .checkbox {
      margin-left: 50%;
      grid-area: z;
      display: flex;
      flex-direction: row-reverse;
      label {
        font-size: 14px;
        word-break: normal;
        width: max-content;
      }
    }
    .results {
      grid-area: b;
    }
    .date {
      grid-area: c;
    }
    .general-control {
      grid-area: d;
    }
    .affectivity {
      grid-area: e;
    }
    .personality-organization {
      grid-area: f;
    }
    .agressivity {
      grid-area: g;
    }
    .emotionality {
      grid-area: h;
    }
    .inpulsiviness {
      grid-area: i;
    }
    .interpessonal-relationship {
      grid-area: j;
    }
    .vital-energy {
      grid-area: k;
    }
    .psychic {
      grid-area: l;
    }
    .textarea-container {
      grid-area: m;
    }
    label {
      white-space: pre;
    }
    textarea {
      height: 59px;
    }
    ${media.lessThan('medium')`
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'z z'
      'a b '
      'c d'
      'e f'
      'g i'
      'j h'
      'k l'
      'm m'
      '. w';
      .checkbox {
        margin-left:60%;
      }
    `}

    ${media.lessThan('small')`
      display: flex;
      flex-direction: column;
      .checkbox {
        margin-left:0%;
      }
    `}
    .import-files {
      display: flex;
      grid-area: w;
      align-items: center;
      ${media.lessThan('medium')`
      margin-left: 30%;
      `}
      Button {
        width: 20%;
        background: ${theme.colors.mainBg};
        border-radius: 0;

        &:hover {
          filter: brightness(1);
        }
      }
    }
    gap: 10px;
    margin: -3px 8px 0 8px;
    padding: 12px;
    border-radius: 0 0 ${theme.border.smallRadius} ${theme.border.smallRadius};
    background: ${theme.colors.mainBg};
  `}
`
